export const trackMidaABTestEvent = async (event: string) => {
  if (window.mida?.isLoaded) {
    await window.mida.track(event)
    return
  }
  window.mdq = window.mdq || []
  window.mdq.push(["track", event])
}
